export default function initBurger() {
  const burger = document.querySelectorAll('.burger');
  const menu = document.querySelector('.menu');

  burger.forEach((burgerButton) => {
    burgerButton.addEventListener('click', function () {
      itemClick()
    });
  });

  // close menu after link clicked
  const menuLinks = document.querySelectorAll('.menu a');

  menuLinks.forEach((link) => {
    link.addEventListener('click', function () {
      itemClick()
    });
  });

  function itemClick() {
    burger.forEach((burgerElement) => {
      let isExpanded = burgerElement.getAttribute('aria-expanded') === 'true';
      burgerElement.setAttribute('aria-expanded', !isExpanded);
      burgerElement.classList.toggle('open');
    });

    let isMenuExpanded = menu.getAttribute('aria-expanded') === 'true';
    menu.setAttribute('aria-hidden', isMenuExpanded);
    menu.setAttribute('aria-expanded', !isMenuExpanded);
    menu.classList.toggle('open');
  }
}

